import {
	AI_QUESTION1_ID,
	AI_QUESTION1_KEY,
	AI_QUESTION2_ID,
	AI_QUESTION2_KEY,
	NEXT_BUTTON_ID,
	NEXT_BUTTON_KEY,
	PROCESSING_LABEL_ID,
	PROCESSING_LABEL_KEY,
	STATE_ID,
	STATE_KEY,
	EXPLANATION_TEXT_ID,
	EXPLANATION_TEXT_KEY,
} from '../constants';

const AI_FORM_CONTENT_DATA = [
	{
		order: 1,
		subId: STATE_ID,
		cells: [
			{
				order: 0,
				fields: [STATE_KEY],
				width: '100',
			}],
	},
	{
		order: 2,
		subId: PROCESSING_LABEL_ID,
		cells: [
			{
				order: 0,
				fields: [PROCESSING_LABEL_KEY],
				width: '100',
			}],
	},
	{
		order: 3,
		subId: EXPLANATION_TEXT_ID,
		cells: [
			{
				order: 0,
				fields: [EXPLANATION_TEXT_KEY],
				width: '100',
			}],
	},
	{
		order: 4,
		subId: AI_QUESTION1_ID,
		cells: [
			{
				order: 0,
				fields: [AI_QUESTION1_KEY],
				width: '100',
			}],
	},
	{
		order: 5,
		subId: AI_QUESTION2_ID,
		cells: [
			{
				order: 0,
				fields: [AI_QUESTION2_KEY],
				width: '100',
			}],
	},
	{
		order: 6,
		subId: NEXT_BUTTON_ID,
		cells: [
			{
				order: 0,
				fields: [NEXT_BUTTON_KEY],
				width: '100',
			}],
	},
];

export default AI_FORM_CONTENT_DATA;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/resources/layout.js